export enum CustomSupervisionActionTypes {
    ASSIGN = 1,
    REMOVE = 2
}